import { modelHelperModule } from './model-helper';
import { getUser } from '../utils/account-utils/account-utils';

export const solutionReviewModelModule = angular
  .module('Q.models.solution-review', [modelHelperModule])

  .factory('SolutionReview', function (DS, ModelHelper, $injector) {
    const currentUser = getUser.bind(null, $injector);

    const SolutionReview = ModelHelper.defineResource({
      name: 'SolutionReview',
      endpoint: 'solution_reviews',

      methods: {
        isMyReview() {
          return this.reviewedBy === currentUser();
        },
        reviewerName(staffName = 'Qualified Staff') {
          return (
            (this.reviewedBy && this.reviewedBy.nameOrEmail) ||
            (this.reviewedByStaff ? staffName : '(Unknown Reviewer)')
          );
        },
        isSubmitted() {
          return (
            !!this.assessmentResultReview &&
            this.assessmentResultReview.isSubmitted()
          );
        },
        shouldShow() {
          return (
            this.isMyReview() || !this.reviewedByStaff || this.isSubmitted()
          );
        },
      },
      staticMethods: {
        getFor(solution, teamMember) {
          let tm = teamMember || currentUser();
          return (
            tm &&
            SolutionReview.filter({
              solutionId: solution.id,
              reviewedById: tm.id,
            })[0]
          );
        },
      },

      relations: {
        hasOne: {
          TeamMember: {
            localField: 'reviewedBy',
            localKey: 'reviewedById',
          },
        },
        belongsTo: {
          Assessment: {
            localField: 'assessment',
            localKey: 'assessmentId',
          },
          AssessmentResult: {
            localField: 'assessmentResult',
            localKey: 'assessmentResultId',
          },
          AssessmentResultReview: {
            localField: 'assessmentResultReview',
            localKey: 'assessmentResultReviewId',
          },
          Challenge: {
            localField: 'challenge',
            localKey: 'challengeId',
          },
          Solution: {
            localField: 'solution',
            localKey: 'solutionId',
          },
          TeamCandidate: {
            localField: 'teamCandidate',
            localKey: 'teamCandidateId',
          },
        },
        hasMany: {
          ReviewQuality: [
            {
              localField: 'positiveQualities',
              localKeys: 'positiveQualityIds',
            },
            {
              localField: 'negativeQualities',
              localKeys: 'negativeQualityIds',
            },
          ],
        },
      },

      meta: {
        fetchOnPush: (data) => {
          // only store the review if we have the assessment result
          return DS.get('AssessmentResult', data.assessmentResultId || '');
        },
      },
    });

    return SolutionReview;
  });
